import CryptoJS from "crypto-js";

const secretKey = process.env.VUE_APP_SECRET_KEY;

export function encrypted(data) {
	return CryptoJS.AES.encrypt(
        JSON.stringify(data),
        secretKey
    ).toString()
}


export function decrypted(data){
    const bytes = CryptoJS.AES.decrypt(data,secretKey)

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
}